<template>
  <div id="order-placed-div">
    <h4 class="fw-bold">Your order has been placed successfully.</h4>
    <h4 class="fw-bold">
      You will receive the tickets in electronic format at the email address
      provided.
    </h4>
  </div>
</template>

<script>
export default {
  name: "OrderConfirmation",
};
</script>

<style scoped>
#order-placed-div {
  margin-top: 250px;
}
</style>
